export const GET_WAREHOUSES = 'GET_WAREHOUSES';
export const GET_WAREHOUSE_STATUS = 'GET_WAREHOUSE_STATUS';
export const GET_WAREHOUSE_CARGO_CONSOLIDATION = 'GET_WAREHOUSE_CARGO_CONSOLIDATION';
export const GET_WAREHOUSE_CARGO_CONSOLIDATION_GRAPH = 'GET_WAREHOUSE_CARGO_CONSOLIDATION_GRAPH';
